import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { Trans, useTranslation } from 'react-i18next'

import { infoCircleIcon, wrenchIcon } from '../../helpers/iconHelpers'
import './ProfileUpdatesUnavailableModal.sass'

const ProfileUpdatesUnavailableModal = ({ onHide }) => {
	const { t } = useTranslation('translation', { keyPrefix: 'profileUpdatesUnavailableModal' })

	return (
		<Modal
			show
			centered
			onHide={onHide}
			className="profile-updates-unavailable-modal"
			aria-labelledby="profile-updates-unavailable-title"
		>
			<Modal.Header closeButton>
				<div className="icon-wrapper" aria-hidden="true">
					{wrenchIcon}
				</div>
				<Modal.Title id="profile-updates-unavailable-title">
					{t('title')}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<p>
					<Trans t={t} i18nKey="textDescription" components={{ bold: <strong /> }} />
				</p>
				<div className="info-box">
					{infoCircleIcon}
					<span className="info-text">{t('textOtherSystemsOperational')}</span>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<span className="status-dot" aria-hidden="true" />
				<span className="status-text">{t('textSystemStatusOperational')}</span>
			</Modal.Footer>
		</Modal>
	)
}

ProfileUpdatesUnavailableModal.propTypes = {
	onHide: PropTypes.func.isRequired,
}

export default ProfileUpdatesUnavailableModal;
